module.exports = __webpack_public_path__ + "img/C03TechLongswordsmanChampion_ua.795cf291.webp";